<template>
  
    <header class="iq_header_1">
              <div class="container">
                  <!--Logo Wrap Start-->
                  <div class="iq_logo">
                      <a href="#/"><img src="../assets/images/companylogo.png" alt="Iqoniq Themes" class="img-responsive" width="150"></a>
                    </div>
                    <!--Logo Wrap Start-->
                    <!--Top Strip Wrap Start-->
                    <div class="iq_ui_element">
                        <!--Top Strip Wrap Start-->
                        <div class="iq_top_strip">
                          <div class="iq_top_contact pull-left">
                              <a href="#"> Call us : +2348033370339 | +2348099523015 | +2348052491930</a>
                                <a href="#"> Email :  info@leniveauconsult.com or info.niveau@gmail.com </a>
                            </div>
                            <div class="iq_time_wrap pull-right"><i class="fa fa-clock-o"></i> Mon - Fri : 09:00 am - 05:00 pm </div>
                        </div>
                        <!--Top Strip Wrap End-->
                        <!--Navigation wrap Start-->
                        <div class="navigation-wrapper pull-left">
                            <div class="navigation pull-left">
                              <ul>
                        <li class=""><router-link to="/">Home</router-link></li>
                        <li><router-link to="/about">About Us</router-link></li>
                        <li><router-link to="/services">Services</router-link></li>
                        <li><router-link to="/partners">Partners</router-link></li>
                        <li><router-link to="/Application">Application</router-link></li>
                        <li><router-link to="/contact">Contact Us</router-link></li>
                        <li><router-link to="/login">login</router-link></li>
                        
                      </ul>
                            </div>
                            <!--DL Menu Start-->
                            <div id="mg-responsive-navigation" class="dl-menuwrapper">
                                <button class="dl-trigger" :class="{'dl-active':dl_active}" @click="toggleClass">Open Menu</button>
                                <ul class="dl-menu" :class="{ 'dl-menuopen':dl_menuopen}">
                                    <li class="menu-item mg-parent-menu">
                                        <router-link to="/">Home</router-link>
                                    </li>
                                    <li><router-link to="/about">About Us</router-link></li>
                                    <li class="menu-item mg-parent-menu"><router-link to="/services">Services</router-link></li>
                                    <li class="menu-item mg-parent-menu"><router-link to="/partners">Partners</router-link></li>
                                    <li class="menu-item mg-parent-menu"><a href="#">Apply</a></li>
                                    <li class="menu-item mg-parent-menu"><router-link to="/contact" href="#">Contact Us</router-link></li>
                                </ul>
                            </div>
                            <!--DL Menu END-->
                            <!--Search Wrap Start-->
                            <!-- <div class="iq_search pull-right">
                                <button data-toggle="modal" data-target="#search-box"><i class="fa fa-search"></i></button>
                            </div> -->
                          <!--Search Wrap End-->
                        </div>
                        <!--Navigation wrap End-->
                    </div>
                    <!--Top Strip Wrap End-->
                </div>
            </header>
</template>

<script>
import * as $ from 'jquery';
export default {
  name: "navigation",
  data(){
    return {
      dl_active: false,
      dl_menuopen: false
    }
  },
  methods:{
    toggleClass(){
      this.dl_active = !this.dl_active;
      this.dl_menuopen = !this.dl_menuopen
      // this.$emit("toggleclass");
    }
  }
};
</script>

<style scoped>
  
</style>
